import { SettingsRoutes } from '@/router/routes';

export enum GuideItemType {
  SETTINGS = 'settings',
  DOC = 'doc',
  COMPOSITE = 'composite',
}

export interface GuideSubItemConfig {
  key: string;
  labelKey: string;
  route?: SettingsRoutes;
}

export interface GuideItemConfig {
  key: string;
  type: GuideItemType;
  titleKey: string;
  descriptionKey: string;
  route?: SettingsRoutes;
  docUrl?: string;
  completableOnClick?: boolean;
  subItems?: GuideSubItemConfig[];
}

export const GUIDE_ITEMS_CONFIG: GuideItemConfig[] = [
  {
    key: 'DEPARTMENTS',
    type: GuideItemType.SETTINGS,
    titleKey: 'items.departments.title',
    descriptionKey: 'items.departments.description',
    route: SettingsRoutes.Departments,
  },
  {
    key: 'ROLES',
    type: GuideItemType.SETTINGS,
    titleKey: 'items.roles.title',
    descriptionKey: 'items.roles.description',
    route: SettingsRoutes.Roles,
  },
  {
    key: 'SENIORITIES',
    type: GuideItemType.SETTINGS,
    titleKey: 'items.seniorities.title',
    descriptionKey: 'items.seniorities.description',
    route: SettingsRoutes.Seniorities,
  },
  {
    key: 'GENERAL_SETTINGS',
    type: GuideItemType.SETTINGS,
    titleKey: 'items.generalSettings.title',
    descriptionKey: 'items.generalSettings.description',
    route: SettingsRoutes.General,
    completableOnClick: true,
  },
  {
    key: 'PERMISSIONS',
    type: GuideItemType.COMPOSITE,
    titleKey: 'items.permissions.title',
    descriptionKey: 'items.permissions.description',
    subItems: [
      {
        key: 'PERMISSIONS_PAGE_VISITED',
        labelKey: 'items.permissions.goToPermissions',
        route: SettingsRoutes.Permissions,
      },
      {
        key: 'PERMISSIONS_USER_ASSIGNED',
        labelKey: 'items.permissions.assignPermission',
        route: SettingsRoutes.Permissions,
      },
    ],
  },
  {
    key: 'DOC_BILLING_PROJECTS',
    type: GuideItemType.DOC,
    titleKey: 'items.docBillingProjects.title',
    descriptionKey: 'items.docBillingProjects.description',
    docUrl: '#',
  },
  {
    key: 'DOC_BILLING_TEAM_MEMBERS',
    type: GuideItemType.DOC,
    titleKey: 'items.docBillingTeamMembers.title',
    descriptionKey: 'items.docBillingTeamMembers.description',
    docUrl: '#',
  },
  {
    key: 'DOC_ASSIGNMENTS',
    type: GuideItemType.DOC,
    titleKey: 'items.docAssignments.title',
    descriptionKey: 'items.docAssignments.description',
    docUrl: '#',
  },
  {
    key: 'DOC_TIME_TRACKING',
    type: GuideItemType.DOC,
    titleKey: 'items.docTimeTracking.title',
    descriptionKey: 'items.docTimeTracking.description',
    docUrl: '#',
  },
];
